import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosOrdenTrabajoEnumChoice,
  TABLE_CONSTANTS_COLUMS,
  convertHourDate,
  formatGetHour,
  gridSizeMdLg6,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchOrdenTrabajosInterval, useUpdateOrdenTrabajo } from '@/shared/actions/erp';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import { AlertSeverityEnum, OrdenTrabajo, OrdenTrabajoNew } from '@/shared/interfaces';
import { useColumnsInstalacionesOT } from '../../../shared/hooks';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useState } from 'react';
import { Badge, Grid, IconButton, Tooltip } from '@mui/material';
import TimeClockComponente from '@/shared/components/ui/TimeClock/TimeClockComponente';
import { useForm } from 'react-hook-form';
import { useUiStore } from '@/store/ui';
import dayjs from 'dayjs';
import { Timer } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ShowContractsAgendaModal from '@/erp/operaciones/agendamiento/shared/components/forms/ShowContractsAgendaModal';
import ResumenTrasladoTecnicoModal from '@/erp/tecnico/orden-trabajo/shared/components/tables/fotos/traslado/ResumenTrasladoTecnicoModal';
import { resumenFotosTraslado } from '@/erp/tecnico/orden-trabajo/shared/components/tables/fotos/traslado/fotos-traslado.utils';
import { esOrdenVisita, resumenFotosVisita } from '@/erp/tecnico/orden-trabajo/shared/components/tables/fotos/fotos-visita.utils';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
interface InstallAsignadaTecnicoOTByStateForm {
  hora_inicio: string | null;
  hora_fin: string | null;
  id_orden_trabajo: string;
}

export type InstallAsignadaTecnicoOTByStateProps = {
  otState: EstadosOrdenTrabajoEnumChoice;
  showActions?: boolean;
  tipoOrdenServicio?:string;
  // Excluir por tipo de servicio (ej. sacar TRASLADO de la lista de instalaciones).
  tipoOrdenServicioExclude?:string;
};


const InstallAsignadaTecnicoOTByState: React.FC<InstallAsignadaTecnicoOTByStateProps> = ({
  otState,
  showActions=true,
  tipoOrdenServicio,
  tipoOrdenServicioExclude,
 }) => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);
  const [key, setKey] = useState(0);
  // Traslados: reemplazar acciones de instalación (registrar hora / documentos)
  // por un botón "Ver" con el resumen de lo que hizo el técnico.
  const esTraslado = tipoOrdenServicio === 'TRASLADO';
  const [resumenOT, setResumenOT] = useState<any>(null);

  const setAlert = useUiStore(s => s.setAlert);

  //USEFORMULARIO
  const form = useForm<InstallAsignadaTecnicoOTByStateForm>({
    //resolver: yupResolver(newProspectoSchema)
  });

  const refreshComponent = () => {
    setKey((prevKey) => prevKey + 1);
  };

  const { mutateAsync: mutateAsyncOrdenTrabajo, } = useUpdateOrdenTrabajo<OrdenTrabajoNew>({ enableSuccessAlert: false });
  const {
    reset,
    control,
    formState: { errors },
  } = form;

  const [openModalEdit, setOpenModalEdit] = useState<boolean>(false);
  // const [openModalDocuments, setOpenModalDocuments] = useState<boolean>(false);
  // const [dataOrdenTrabajo, setDataOrdenTrabajo] = useState<OrdenTrabajo>();
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: OrdensTrabajoPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOrdenTrabajosInterval({
    enabled: true,
    params: {
      order_by_3: 'hora_inicio',
      order_by_2: 'fecha_instalacion',
      order_by: 'hora_instalacion',
      //order_up_3: false,
      order_up_2: true,
      order_up: true,
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: true,
      estado_orden_trabajo: otState,
      tipo_orden_servicio:tipoOrdenServicio,
      tipo_orden_servicio_exclude:tipoOrdenServicioExclude
    },
  });

  ///* columns
  const {
    instalacionesAsignadasColumns,
  } = useColumnsInstalacionesOT();




  return (
    <>
      <TableTabsScene
        globalFilter={globalFilter}
        onChangeFilter={onChangeFilter}
        searchInputText="por identificación"
        //onChangeRangeDate={onChangeRangeDate}
        cleanFilter={cleanFilter}
      >
        <GeneralTable<OrdenTrabajo>
          key={key}
          columns={instalacionesAsignadasColumns}
          data={OrdensTrabajoPagingRes?.data?.data || []}
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={OrdensTrabajoPagingRes?.data?.count}
          // // actions ========
          enableColumnActions={showActions}
          enableEditing={showActions}
          // crud
          canEdit={false}
          // canDelete={false}
          // onEdit={(row) => {
          // }}
          actionsColumnSize={60}
          showCustomActionBtnSpace={showActions}
          customActionBtnSpace={(value) => {
            if(!showActions)
              return

            // Traslado: solo "Ver" (resumen del técnico), sin registrar hora ni documentos.
            if (esTraslado) {
              // Si Activaciones eliminó fotos (quedan marcadas en la OT), se
              // resalta la fila: el técnico abre el resumen y las vuelve a subir.
              // Solo aplica a traslados ya REALIZADOS (mientras está en curso
              // se completa desde el propio formulario, pestaña FOTOS).
              const fotosIncompletas =
                otState === EstadosOrdenTrabajoEnumChoice.REALIZADA &&
                (value as any)?.urls_fotos_ingreso !== undefined &&
                resumenFotosTraslado(value).incompleto;
              return (
                <Tooltip
                  title={
                    fotosIncompletas
                      ? "Activaciones eliminó fotos. Ábrelo para volver a subirlas."
                      : "Ver resumen del técnico"
                  }
                >
                  <IconButton
                    color={fotosIncompletas ? "warning" : "info"}
                    onClick={() => setResumenOT(value)}
                  >
                    <Badge color="warning" variant="dot" invisible={!fotosIncompletas}>
                      <VisibilityIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )
            }

            // Visita: si Activaciones eliminó fotos (marcas en la OT), se avisa en
            // la fila; el técnico las repone desde la pestaña FOTOS de la orden
            // (en curso) o abriéndola con "Actualizar" (ya realizada).
            const fotosVisitaIncompletas =
              esOrdenVisita(value) &&
              (value as any)?.urls_fotos_ingreso !== undefined &&
              resumenFotosVisita(value).incompleto;

            return (
              <Grid container>
                <Grid item>
                  {fotosVisitaIncompletas && (
                    <Tooltip title="Activaciones eliminó fotos de esta visita. Abre la orden para volver a subirlas (pestaña FOTOS).">
                      <IconButton color="warning">
                        <Badge color="warning" variant="dot">
                          <WarningAmberIcon />
                        </Badge>
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Registrar hora de Inicio">
                    <IconButton
                      onClick={() => {
                        if (dayjs(value.fecha_instalacion) > dayjs(new Date)) return setAlert(true, 'Esta opción aún no está habilitada.', AlertSeverityEnum.info);
                        try {
                          reset({
                            id_orden_trabajo: value.id_orden_trabajo,
                            hora_inicio: convertHourDate(value.hora_inicio as string),
                            hora_fin: convertHourDate(value.hora_fin as string),
                          });

                          setOpenModalEdit(true)
                        } catch (error) {
                          return setAlert(true, 'Ha ocurrido un error. Recargue la página o espere un momento por favor.', AlertSeverityEnum.error);
                        }
                      }}
                    >
                      <Timer />
                    </IconButton>
                  </Tooltip>

                  <ShowContractsAgendaModal
                    ordenTrabajoId={value!.id_orden_trabajo}
                    razonSocial={value?.prospecto_data?.razon_social}
                    contrato={value!.contrato_data!}
                    showBtnGenDocs={false}
                    showBtnForward={false}
                    showBtnCopy={false}
                    idPreventa={value.preventa_data?.id_preventa}
                  />
                  {/* <Tooltip title="Generar Documentos">
                    <IconButton
                        onClick={() =>{
                          setOpenModalDocuments(true)
                          setDataOrdenTrabajo(value)
                        }}
                      >
                        <SummarizeOutlined />
                    </IconButton>
                  </Tooltip> */}

                </Grid>
              </Grid>
            )
          }}
        />
      </TableTabsScene>

      {
        openModalEdit && (
          <ScrollableDialogProps
            open={openModalEdit}
            title="Ingreso/Salida del tecnico"
            cancelTextBtn="Cerrar"
            onCloseIcon={() => setOpenModalEdit(false)}
            onConfirm={async () => {

              if (!form.getValues().hora_inicio && !form.getValues().hora_fin) return setAlert(true, 'Ingrese una hora de inicio o una hora de fin.', AlertSeverityEnum.warning);
              const data: any = {
                hora_inicio: formatGetHour(form.getValues().hora_inicio),
                hora_fin: formatGetHour(form.getValues().hora_fin)
              }
              const resp = await mutateAsyncOrdenTrabajo({
                id: form.getValues().id_orden_trabajo,
                data: data
              })

              if (resp.code == 200) {
                refreshComponent();
                //window.location.reload();
              }

              setOpenModalEdit(false);
            }}
            minWidth="40%"
            contentNode={
              <Grid container spacing={2}>

                <TimeClockComponente
                  size={gridSizeMdLg6}
                  control={control}
                  error={errors.hora_inicio}
                  helperText={errors.hora_inicio?.message}
                  label='Hora de inicio técnico'
                  name='hora_inicio'
                  disabled={!!form.getValues()?.hora_inicio}
                />

                <TimeClockComponente
                  size={gridSizeMdLg6}
                  control={control}
                  error={errors.hora_fin}
                  helperText={errors.hora_fin?.message}
                  label='Hora de fin técnico'
                  name='hora_fin'
                  disabled={!!form.getValues()?.hora_fin}
                />

              </Grid>
            }
          />
        )
      }

      {resumenOT && (
        <ResumenTrasladoTecnicoModal
          open={!!resumenOT}
          onClose={() => setResumenOT(null)}
          ordenTrabajo={resumenOT}
          permitirCompletar={otState === EstadosOrdenTrabajoEnumChoice.REALIZADA}
        />
      )}

      {/* {
        openModalDocuments && (
          <ShowContractsAgendaModal
            // open={openModalDocuments}
            // onClose={()=>setOpenModalDocuments(false)}
            ordenTrabajoId={dataOrdenTrabajo!.id_orden_trabajo}
            razonSocial={dataOrdenTrabajo?.prospecto_data?.razon_social}
            contrato={dataOrdenTrabajo!.contrato_data!}
            // onConfirm={()=>setOpenModalDocuments(false)}
            //Solo para pyl
            showBtnGenDocs={false}
            // isLoading={isLoading}
            // isRefetching={isRefetching}
          />
        )
      } */}
      {/* {
        openModalDocuments && (
          <ShowContractsAgendaModal
            open={openModalDocuments}
            onClose={()=>setOpenModalDocuments(false)}
            agenda={}
            form={}
            onConfirm={}
          />
        )
      } */}
    </>
  );
};

export default InstallAsignadaTecnicoOTByState;
